import Layout from "components/Layout";
import React from "react";
import ManualEditForm from "./components/ManualEditForm";

function AdminManualEditPage() {
  return (
    <Layout title="매뉴얼 수정/삭제">
      <ManualEditForm />
    </Layout>
  );
}

export default AdminManualEditPage;
